import { render, staticRenderFns } from "./CounselorByEthnicity.vue?vue&type=template&id=2bc96268&scoped=true&"
import script from "./CounselorByEthnicity.vue?vue&type=script&lang=js&"
export * from "./CounselorByEthnicity.vue?vue&type=script&lang=js&"
import style0 from "./CounselorByEthnicity.vue?vue&type=style&index=0&id=2bc96268&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc96268",
  null
  
)

export default component.exports